module.exports = __webpack_public_path__ + "img/Support.9481a8a2.svg";